<script>
    import _            from 'lodash'
    import { onMount }  from 'svelte'
    import { fly }      from 'svelte/transition'
    import validate     from 'validate.js'
    import { company }  from '../../shared/stores'
    import FieldError   from '../../shared/FieldError.svelte'
    import * as api     from '../../shared/api.js'
    import AppLoader    from '../../shared/Loader.svelte'    
    import SectionTitle from '../../shared/SectionTitle.svelte'

    export let _company = null
    export let location = null

    let mountError = false
    let buffer     = []
    let loading    = true
    let working    = false
    let error      = false
    let email      = null

    const constraints = {
        email : { 
            presence : { allowEmpty: false, message: "campo obrigatório" }, 
            email    : {                    message: "email inválido"    } 
        }
    }

    onMount(() => {
        mountError = false
        api
            .get(`/dpo/company/${_company}`)
            .then(api.toJsonIf200)
            .then(json => {
                loading = false
                buffer = sorted(json.filter(it => it.type === 'synthetic'))
            })
            .catch(err => {
                mountError = true
            })
    })

    function sorted(array) {
        return _.sortBy(array, i => i.name)
    }

    function notifyError(err) {
        error = err
        setTimeout(() => error = null, 5000)
    }

    function grantAccess() {
        working = true
        api
            .post("/dpo/grant", { company: parseInt(_company), email })
            .then(api.toJsonIf200)
            .then(json => {
                working = false
                email   = null
                buffer  = sorted([...buffer, json]) 
            })
            .catch(err => {
                working = false
                notifyError(err)
            })
    }

    function revokeAccess(address) {
        return () => {
            working = true
            api
                .post("/dpo/revoke", { company: parseInt(_company), email: address })
                .then(res => {
                    working = false
                    if(res.status === 200) {
                        buffer = buffer.filter(it => it.email !== address)
                    } else {
                        notifyError(res)
                    }
                })
                .catch(err => {
                    working = false
                    notifyError(err)
                })
        }
    }

    function validateItem(email) {
        if(_.isEmpty(email)) {
            return {}
        } else {
            return validate({ email }, constraints, { fullMessages: false }) || {}
        }
    }

    $: errors   = validateItem(email)
    $: disabled = _.isEmpty(email) || Object.keys(errors).length !== 0
</script>

<svelte:head>
	<title>Dogma / DPOs</title>
</svelte:head>

{#if loading || mountError}
    <AppLoader error={mountError} what="Carregando" inverted={true}/>
{:else}
    <SectionTitle>DPOs</SectionTitle>
    <div class="ui raised segments">
        <div class="ui dpo segment">
            <div>
                <form class="ui form">
                    <div class="field" class:error={errors.email} class:disabled={working}>
                        <label>Email</label>
                        <input type="text" name="email" placeholder="email" bind:value={email}>
                        {#if error}
                            <i transition:fly="{{ x: -20, duration: 700 }}" class="ui red error label">erro</i>
                        {/if}
                    </div>
                    <FieldError style="label" property={errors['email']}/>
                </form>                
            </div>
            <button class="ui blue button" class:loading={working} class:disabled={disabled || working} on:click={grantAccess}>Novo Acesso</button>
        </div>
    {#each buffer as item (item.id)}
            <div class="ui dpo segment">
                <div>
                    <h2 class="ui header">{item.name}</h2>
                    <h3 class="ui header">{item.email}</h3>
                </div>
                <button class="ui button" on:click={revokeAccess(item.email)} class:disabled={working}>Revogar Acesso</button>
            </div>
        {/each}
    </div>    
{/if}

<style>
    .dpo {
        display: flex;
        align-items: center;
    }

    .dpo > div {
        flex: 1;
    }

    .dpo input {
        width: 300px;
    }

    small {
        font-size: 60%;
    }

    h2.header {
        font-weight: 400;
        margin-bottom: 0;
    }

    h3.header {
        margin-top: 0;
        font-weight: 300;
        color: #ddd;
    }

    .error.label {
        margin-left: 2em;
        vertical-align: bottom;
    }

</style>